exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".translations[data-v-27e34aa2]{max-height:400px;overflow-y:auto}.translations-list tbody tr:first-child td[data-v-27e34aa2]{border-top:none}.clear-translation-keyword[data-v-27e34aa2]{position:absolute;top:-6px;right:51px;z-index:9}", ""]);

// exports
